import { Main } from '../Main/Main';
import { Loader } from '../Loader/Loader';

export function LoaderPage(): JSX.Element {
	return (
		<Main>
			<Loader />
		</Main>
	);
}
